import client from './client';

export const createAvatar = async (svgData) => {
    const response = await client.post('/avatars', { svg_data: svgData });
    return response.data;
};

export const getAvatar = async (avatarId) => {
    const response = await client.get(`/avatars/${avatarId}`);
    return response.data;
};

export const updateAvatar = async (avatarId, svgData) => {
    const response = await client.put(`/avatars/${avatarId}`, { svg_data: svgData });
    return response.data;
};
